import React from "react";
import { Switch, Route } from "react-router-dom";
import {
  PeopleOutline,
  SpeedOutlined,
  EmojiEventsOutlined,
  InsertDriveFileOutlined,
  SettingsOutlined,
} from "@material-ui/icons";

import * as ROUTES from "../../constants/routes";
import { withAuthorization } from "../Session";
import { DashboardLayout } from "../UI";
import QueryProvider from "./QueryProvider";
import Stats from "./Stats";
import Participants from "./Participants";
import Winners from "./Winners";
import Promotional from "./Promotional";
import Settings from "./Settings";

const NAV_ITEMS = [
  {
    label: "Dashboard",
    icon: <SpeedOutlined />,
    route: ROUTES.HRDASHBOARDHOME,
  },
  {
    label: "Participants",
    icon: <PeopleOutline />,
    route: ROUTES.HRDASHBOARDPARTICIPANTS,
  },
  {
    label: "Winner Report",
    icon: <EmojiEventsOutlined />,
    route: ROUTES.HRDASHBOARDWINNERS,
  },
  {
    label: "Promotional Material",
    icon: <InsertDriveFileOutlined />,
    route: ROUTES.HRDASHBOARDPROMOTIONAL,
  },
  {
    label: "Settings",
    icon: <SettingsOutlined />,
    route: ROUTES.HRDASHBOARDSETTINGS,
  },
];

const HRDashboard = () => (
  <QueryProvider>
    <DashboardLayout navItems={NAV_ITEMS}>
      <Switch>
        <Route path={ROUTES.HRDASHBOARDHOME} component={Stats} />
        <Route
          path={ROUTES.HRDASHBOARDPARTICIPANTS}
          component={Participants}
        />
        <Route path={ROUTES.HRDASHBOARDWINNERS} component={Winners} />
        <Route path={ROUTES.HRDASHBOARDPROMOTIONAL} component={Promotional} />
        <Route path={ROUTES.HRDASHBOARDSETTINGS} component={Settings} />
        <Route exact path={ROUTES.HRDASHBOARD} component={Stats} />
      </Switch>
    </DashboardLayout>
  </QueryProvider>
);

const condition = () => true;

export default withAuthorization(condition, ROUTES.USERDASHBOARD)(HRDashboard);
